import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import HeroContacto from "./sections/HeroContacto";
import FormularioDeContacto from "./sections/FormularioDeContacto";
import InformaciNDeContacto from "./sections/InformaciNDeContacto";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <HeroContacto />
      <FormularioDeContacto />
      <InformaciNDeContacto />
      <Footer />
    </div>;
}